import React, { useEffect } from "react";
import controllers from "../../controllers/teams";
import LoaderData from "../../component/LoaderData/LoaderData";
import { useTranslation } from "react-i18next";

const TeamTwo = (props) => {
  const { i18n } = useTranslation();
  const isEnglish = i18n.language === "en";

  const [data, setData] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  useEffect(() => {
    const getTeamsList = () => {
      setLoading(true);
      return controllers
        .getTeamsList({
          limit: 100,
          page: 0,
        })
        .then((response) => {
          setData(response);
          setTimeout(() => {
            setLoading(false);
          }, 400);
        })
        .catch((error) => {
          setLoading(false);
          window.location.href = "/500";
        });
    };
    getTeamsList();
  }, []);

  return (
    <div className="row">
      {(!data && !loading) ||
        (data.length === 0 && !loading && (
          <h4 style={{ margin: "50px auto", color: "#c4c4c4" }}>
            {isEnglish ? "No Team found !" : "Aucune Team trouvée !"}
          </h4>
        ))}
      {loading ? (
        <LoaderData />
      ) : (
        data &&
        data.length > 0 &&
        data.map((team, index) => (
          <div
            id="team-static"
            className={`${props.column} text-center`}
            key={index}
          >
            <div className={`team ${props.teamStyle}`}>
              <div id="teams" className="thumbnail">
                <img
                  className="w-100"
                  src={
                    team.avatar !== "team_avatar.jpg"
                      ? `${process.env.REACT_APP_DOMAIN}/api/teamavatars/${team.id}/${team.avatar}`
                      : `${process.env.REACT_APP_DOMAIN}/api/teamavatars/${team.avatar}`
                  }
                  alt="Team Image"
                />
              </div>
              <div className="content">
                <a
                  href={
                    "/team/" +
                    team.fullname.split(" ").join("-") +
                    "/?id=" +
                    team.id
                  }
                >
                  <h4 className="title">{team.fullname}</h4>{" "}
                </a>
                <p className="designation">{team.status}</p>
              </div>
            </div>
            <div className="inner">
              <div className="content">
                <a
                  href={
                    "/team/" +
                    team.fullname.split(" ").join("-") +
                    "/?id=" +
                    team.id
                  }
                >
                  <h3 className="title">{team.fullname}</h3>{" "}
                </a>
                <p className="designation">{team.status}</p>
              </div>
            </div>
          </div>
        ))
      )}
    </div>
  );
};
export default TeamTwo;
